// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import InfoImg from "./../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import FlagIcon from "./../../../Assets/Images/CommanImages/flag_icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "../QuestionDashboard/questiondashborad.css";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import "./quesbank.css";
// import TablewithCheckbox from "../../../Components/TableComponent/TablewithCheckbox";
// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   setPagePath,
//   renderQuestionText,
//   selectedRows,
//   setSelectedRows,
//   renderQuestionTextModel,
//   toggleImage,
//   expandedStates,
//   questionDetailsMap,
//   handleEyeClick,
//   isLoading = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);
//   const flagCountIndex = headers.indexOf("Flag Count");
//   const statusTextIndex = headers.indexOf("Status");
//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] =
//     useState(false);
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
//   const [changeStatus, setChangeStatus] = useState(false);
//   useEffect(() => {
//     if (headers.length > 0) {
//       const initial = headers
//         .filter((header) => header !== "Status" && header !== "Set ID")
//         .slice(0, 5); // First 5 visible columns
//       setVisibleColumns([
//         headers[0],
//         ...initial.filter((h) => h !== headers[0]),
//       ]);
//     }
//   }, [headers]);

//   const handleColumnSelection = (column) => {
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       if (Object.keys(appliedFilters).length > 0) {
//         // If filters are applied, select only filtered data
//         const filteredIds = paginatedData.map((row) => row[0]);
//         setSelectedRows((prevSelected) => {
//           // Combine previously selected rows with new filtered selections
//           const combined = [...prevSelected, ...filteredIds];
//           // Remove duplicates
//           return [...new Set(combined)];
//         });
//       } else {
//         // If no filters, select all data
//         setSelectedRows(data.map((row) => row[0]));
//       }
//     } else {
//       if (Object.keys(appliedFilters).length > 0) {
//         // If filters are applied, deselect only filtered data
//         const filteredIds = paginatedData.map((row) => row[0]);
//         setSelectedRows((prevSelected) =>
//           prevSelected.filter((id) => !filteredIds.includes(id))
//         );
//       } else {
//         // If no filters, deselect all
//         setSelectedRows([]);
//       }
//     }
//   };
//   // const handleSelectAll = (e) => {
//   //   if (e.target.checked) {
//   //     setSelectedRows(data.map((row) => row[0])); // Assuming the first column contains the question ID
//   //   } else {
//   //     setSelectedRows([]);
//   //   }
//   // };

//   const handleRowSelect = (rowIndex) => {
//     const questionId = paginatedData[rowIndex][0];
//     setSelectedRows((prev) => {
//       if (prev.includes(questionId)) {
//         return prev.filter((id) => id !== questionId);
//       } else {
//         return [...prev, questionId];
//       }
//     });
//   };
//   // const handleRowSelect = (rowIndex) => {
//   //   const questionId = data[rowIndex][0]; // Assuming the first column contains the question ID
//   //   if (selectedRows.includes(questionId)) {
//   //     setSelectedRows(selectedRows.filter((id) => id !== questionId));
//   //   } else {
//   //     setSelectedRows([...selectedRows, questionId]);
//   //   }
//   // };

//   const [columnWidth, setColumnWidth] = useState(400); // Default width for first column
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       ); // Min width: 100px
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   const toggleChangeStatusVisibility = () => {
//     setChangeStatus((prevState) => !prevState);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           {/* <div style={{ display: "flex", alignItems: "center" }}>
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="input-top-tc"
//               onChange={handleSearch}
//             />
//             <img src={searchicon} className="search-icon-tc" alt="search" />
//           </div> */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           // className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(
//                     (header) => header !== "Set ID" && header !== "Status"
//                   )
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                         disabled={column === "Question ID"}
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {/* {data.length > 0 ? ( */}
//       {/* {isLoading ? (
//         <div style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           minHeight: '400px',
//           flexDirection: 'column',
//           gap: '20px'
//         }}>
//           <div className="loader-tc"></div>
//           <span style={{ color: '#6A6A6A', fontSize: '16px' }}>
//             Loading questions, please wait...
//           </span>
//         </div>
//       ) : */}
//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative", // Ensure position for pseudo-element
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                         }}
//                       >
//                         {index === 0 && (
//                           <input
//                             type="checkbox"
//                             className="delete-question-checkbox-dqc"
//                             checked={isAllSelected}
//                             onChange={handleSelectAll}
//                             style={{
//                               width: "20px",
//                               height: "20px",
//                               marginRight: "105px",
//                             }}
//                           />
//                         )}
//                         {heading}
//                         {index === 1 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {visibleColumns.map((column, cellIndex) => (
//                       <td
//                         key={cellIndex}
//                         style={{
//                           width: cellIndex === 1 ? `${columnWidth}px` : "auto",
//                           textAlign: "left",
//                           color: "#6A6A6A",
//                           verticalAlign: "middle",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           maxWidth: `${columnWidth}px`,
//                           width: "200px",
//                         }}
//                       >
//                         {cellIndex === 0 ? ( // Ensure link only appears once
//                           <div
//                             style={{ display: "flex", alignItems: "center" }}
//                           >
//                             <input
//                               type="checkbox"
//                               className="delete-question-checkbox-dqc"
//                               checked={selectedRows.includes(row[0])}
//                               onChange={() => handleRowSelect(rowIndex)}
//                             />
//                             <div
//                               style={{
//                                 width: "100px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                               }}
//                             >
//                               {/* <div className="flag-container-ques-bank-dash">
//                                 {row[7] > 0 && (
//                                   <div className="flag-count-ques-bank-dash">
//                                     <span>{row[7] > 99 ? "99" : row[7]}</span>
//                                   </div>
//                                 )}
//                                 {row[7] > 0 && (
//                                   <img
//                                     src={FlagIcon}
//                                     alt="flag count"
//                                     style={{ width: "24px" }}
//                                   />
//                                 )}
//                               </div> */}
//                               <div className="flag-container-ques-bank-dash">
//                                 {row[flagCountIndex] > 0 && (
//                                   <>
//                                     <div className="flag-count-ques-bank-dash">
//                                       <span>
//                                         {row[flagCountIndex] > 99
//                                           ? "99"
//                                           : row[flagCountIndex]}
//                                       </span>
//                                     </div>
//                                     <img
//                                       src={FlagIcon}
//                                       alt="flag"
//                                       style={{ width: "24px" }}
//                                     />
//                                   </>
//                                 )}
//                               </div>

//                               {/* <div> */}
//                               <span
//                                 style={{
//                                   width: "20px",
//                                   textAlign: "center",
//                                   marginRight: "40px",
//                                 }}
//                               >
//                                 {row[statusTextIndex] === "Marked special" && (
//                                   <span
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleEyeClick(row[0])}
//                                   >
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="eyeicon"
//                                       style={{ width: "20px", height: "20px" }}
//                                     />
//                                   </span>
//                                 )}
//                               </span>
//                             </div>
//                             <Link
//                               style={{ color: "#337ab7" }}
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 const questionId = row[0]; // Assuming first column contains Question ID
//                                 setSelectedQuestion(
//                                   questionDetailsMap[questionId]
//                                 ); // Retrieve from stored data
//                                 setIsQuesModalVisible(true); // Show modal
//                               }}
//                             >
//                               <span
//                                 className="truncated-text"
//                                 title={row[headers.indexOf(column)]}
//                               >
//                                 {headers.indexOf(column) === 2
//                                   ? renderQuestionText(
//                                       row[headers.indexOf(column)]
//                                     ) // Render LaTeX here
//                                   : row[headers.indexOf(column)]}
//                               </span>
//                             </Link>
//                           </div>
//                         ) : (
//                           <span className="truncated-text-2">
//                             {headers.indexOf(column) === 2
//                               ? renderQuestionText(row[headers.indexOf(column)]) // Render LaTeX for LaTeX column
//                               : row[headers.indexOf(column)]}
//                           </span>
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//       <div style={{ textAlign: 'center', padding: '40px', color: '#6A6A6A', fontSize: '16px' }} >
//         No data available
//       </div>
//     )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {/* Show the Reset button only after Apply is clicked */}

//               {/* Always show the Apply button */}
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div
//               className="filter-options-container"
//               style={{
//                 maxHeight: "550px", // Set a maximum height for the container
//                 overflowY: "auto", // Enable vertical scrolling
//                 paddingRight: "10px", // Add padding for better UX
//               }}
//             >
//               {/* {headers.slice(3).map((header, index) => {
//                 const uniqueOptions = [
//                   ...new Set(
//                     data.map((row) => row[index + 3]).filter((option) => option)
//                   ),
//                 ]; */}
//               {/* {headers
//                 .filter((_, index) => index === 0 || (index >= 3 && index !== 4)) // Skip indexes 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0 ? 0 : filteredIndex + 2 + (filteredIndex >= 2 ? 1 : 0); // Adjust for skipped indexes 2 and 4

//                   const uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ]; */}
//               {headers
//                 .filter(
//                   (header) =>
//                     // header !== "Question ID" &&
//                     header !== "Question Text"
//                 )
//                 .map((header) => {
//                   const actualIndex = headers.indexOf(header); // ✅ Get original index directly

//                   const uniqueOptions = [
//                     ...new Set(
//                       data.map((row) => row[actualIndex]).filter(Boolean)
//                     ),
//                   ];

//                   return (
//                     <SelectedValuesDropdown
//                       key={actualIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//       {/* {isQuesModalVisible && selectedQuestion && (
//         <div
//           className="modal-overlay"
//           onClick={() => setIsQuesModalVisible(false)}
//         >
//           <div className="modal-content-all-question">
//             <button
//               className="modal-close-button"
//               onClick={() => setIsQuesModalVisible(false)}
//             >
//               X
//             </button>

//             <div className="modal-header-del">
//               <p
//                 style={{
//                   fontSize: "18px",
//                   backgroundColor: "#D6D6D6",
//                   padding: "8px",
//                 }}
//               >
//                 QUESTION ID # {selectedQuestion.questionId}
//               </p>
//             </div>
//             <div
//               className="modal-question-options"
//               style={{
//                 maxHeight: "600px",
//                 overflowY: "auto",
//                 boxSizing: "border-box",
//               }}
//             >
//               <p style={{ fontSize: "18px" }}>
//                 Question Type: {selectedQuestion.questionType}
//               </p>
//               {selectedQuestion.options.length > 0 ? (
//                 <ul>
//                   <span style={{ fontSize: "18px", fontWeight: "bold" }}>
//                     Question:
//                   </span>
//                   <span style={{ fontSize: "25px", marginLeft: "3px" }}>
//                     {renderQuestionTextModel(selectedQuestion.questionText)}
//                   </span>
//                   {selectedQuestion.options.map((option, index) => (
//                     <li key={index} className="option-list-item">
//                       <div className="toggle-radio">
//                         <input
//                           type="radio"
//                           checked={option.option_correct_flag}
//                           readOnly
//                         />
//                         <div>{renderQuestionTextModel(option.option_text)}</div>
//                       </div>
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p>No options available for this question.</p>
//               )}
//               {selectedQuestion.tags.length > 0 && (
//                 <p
//                   style={{
//                     marginTop: "20px",
//                     fontSize: "18px",
//                     color: "#6A6A6A",
//                   }}
//                 >
//                   {selectedQuestion.tags
//                     .map((tag) => {
//                       if (tag.tag_type === 1) {
//                         return tag.tag_value;
//                       } else if (tag.tag_type === 2 && tag.tag_value != null) {
//                         return tag.tag_name;
//                       }
//                       return null;
//                     })
//                     .filter(Boolean)
//                     .join(", ")}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )} */}
//         {isQuesModalVisible && selectedQuestion && (
//           <div
//             className="modal-overlay"
//             onClick={() => setIsQuesModalVisible(false)}
//             style={{ cursor: "default" }}
//           >
//             {/* outside close icon (plain X, no bg) */}
//             <button
//               className="modal-close-outside"
//               aria-label="Close"
//               onClick={(e) => { e.stopPropagation(); setIsQuesModalVisible(false); }}
//               style={{ lineHeight: "24px" }}
//             >
//               ×
//             </button>

//             <div
//               className="modal-content-all-question"
//               onClick={(e) => e.stopPropagation()}
//               style={{ backgroundClip: "padding-box" }}
//             >
//               {/* Header: keep inline font size, remove bg, add 1px border bottom */}
//               <div className="modal-header-del">
//                 <p
//                   style={{
//                     fontSize: "18px",
//                     color: "#424342",
//                     margin: 0,
//                     padding: "10px 14px",
//                     backgroundColor: "transparent",
//                     borderBottom: "1px solid #d6d6d6",
//                     userSelect: "none"
//                   }}
//                 >
//                   QUESTION ID - {selectedQuestion.questionId}
//                 </p>
//               </div>

//               <div
//                 className="modal-question-options"
//                 style={{
//                   maxHeight: "600px",
//                   overflowY: "auto",
//                   boxSizing: "border-box",
//                   color: "#424342",
//                   backgroundColor: "transparent",
//                   padding: "20px",
//                   WebkitOverflowScrolling: "touch"
//                 }}
//               >
//                 <p style={{ fontSize: "18px", marginTop: 0, color: "#424342" }}>
//                   Question Type: {selectedQuestion.questionType}
//                 </p>

//                 {selectedQuestion.options.length > 0 ? (
//                   <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                     <span style={{ fontSize: "18px", color: "#424342", display: "inline-block" }}>
//                       Question:
//                     </span>
//                     <span style={{ fontSize: "22px", marginLeft: "3px", color: "#424342", verticalAlign: "baseline" }}>
//                       {renderQuestionTextModel(selectedQuestion.questionText)}
//                     </span>

//                     {selectedQuestion.options.map((option, index) => (
//                       <li key={index} className="option-list-item" style={{ listStyle: "none", fontSize: "22px", marginTop: "15px", paddingBottom: "20px" }}>
//                         <label className="toggle-radio" style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "default" }}>
//                           <input type="radio" checked={option.option_correct_flag} readOnly />
//                           <div style={{ color: "#424342" }}>{renderQuestionTextModel(option.option_text)}</div>
//                         </label>
//                       </li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p style={{ color: "#6A6A6A", marginTop: 8 }}>No options available for this question.</p>
//                 )}

//                 {selectedQuestion.tags.length > 0 && (
//                   <p style={{ marginTop: "20px", fontSize: "18px", color: "#6A6A6A", wordBreak: "break-word" }}>
//                     {selectedQuestion.tags
//                       .map((tag) => {
//                         if (tag.tag_type === 1) return tag.tag_value;
//                         if (tag.tag_type === 2 && tag.tag_value != null) return tag.tag_name;
//                         return null;
//                       })
//                       .filter(Boolean)
//                       .join(", ")}
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//     </div>
//   );
// };

// const QuestionBank = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
//   setNoTimeSet,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//   const reviewType = "hod";
//   const reviewLevel = 1;
//   const pageId = "QuestionBank";
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [expandedStates, setExpandedStates] = useState({});
//   const flagCountIndex = headers.indexOf("Flag Count");
//   const statusTextIndex = headers.indexOf("Status");
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     // const decodedQuestion = he.decode(questionText);
//     const decodedQuestion = he.decode(String(questionText || ""));

//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-3">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const toggleImage = (key) => {
//     setExpandedStates((prevStates) => ({
//       ...prevStates,
//       [key]: !prevStates[key], // Toggle based on the unique key
//     }));
//   };

//   const renderQuestionTextModel = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return (
//       <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
//         {questionSegments.map((segment, index) => {
//           if (segment.startsWith("imgsrc=")) {
//             const imageUrl = segment.replace("imgsrc=", "");
//             const key = `${questionText}-${index}`;
//             const isExpanded = expandedStates[key] || false;

//             return (
//               <img
//                 key={index}
//                 src={imageUrl}
//                 alt={`Question Image ${index}`}
//                 style={{
//                   width: "auto",
//                   height: "auto",
//                   maxWidth: isExpanded ? "450px" : "200px",
//                   maxHeight: isExpanded ? "550px" : "250px",
//                   objectFit: "contain",
//                   margin: "0 5px",
//                   verticalAlign: "middle",
//                   cursor: "pointer",
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toggleImage(key);
//                 }}
//               />
//             );
//           } else {
//             return (
//               <span key={index} style={{ margin: "0 5px" }}>
//                 <Latex>{segment}</Latex>
//               </span>
//             );
//           }
//         })}
//       </div>
//     );
//   };

//   // const fetchDashboardData = async () => {
//   const [questionDetailsMap, setQuestionDetailsMap] = useState({}); // Store full question details

//   // const fetchDashboardData = async () => {
//   //   try {
//   //     const response = await fetch(
//   //       `${FULL_API_BASE_URL}/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}&page_id=${pageId}`,
//   //       {
//   //         method: "GET",
//   //         headers: {
//   //           Authorization: `Bearer ${accessToken}`,
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );

//   //     if (!response.ok) {
//   //       throw new Error("Failed to fetch dashboard data.");
//   //     }

//   //     const result = await response.json();
//   //     const { data, status, message } = result;

//   //     if (status !== 200) {
//   //       throw new Error(message || "Failed to fetch dashboard data");
//   //     }

//   //     // Extract headers and rows from the `table_data`
//   //     const rawTableData = data?.table_data || [];
//   //     const rawHeaders = rawTableData[0] || [];
//   //     const rawRows = rawTableData.slice(1) || [];

//   //     const rawHeaderNames = rawHeaders.map((header) =>
//   //       header.replace(/^t\*|d\*|n\*/, "")
//   //     );
//   //     const setIdIndex = rawHeaderNames.indexOf("Set ID");

//   //     const filteredHeaders = rawHeaderNames.filter(
//   //       (header) => header !== "Set ID"
//   //     );

//   //     const transformedRows = rawRows.map((row) =>
//   //       row
//   //         .map((cell, index) => {
//   //           if (rawHeaders[index]?.startsWith("d*")) {
//   //             return new Date(cell).toLocaleDateString("en-US", {
//   //               year: "numeric",
//   //               month: "short",
//   //               day: "2-digit",
//   //             });
//   //           }
//   //           return cell;
//   //         })
//   //         .filter((_, idx) => idx !== setIdIndex)
//   //     );

//   //     // Store the full question data mapped by question ID
//   //     const questionDetails = {};
//   //     (data.result_list || []).forEach((question) => {
//   //       questionDetails[question.question_id] = {
//   //         questionId: question.question_id,
//   //         questionText: question.question_text,
//   //         questionType: question.ques_type,
//   //         options: question.options || [],
//   //         tags: question.tags || [],
//   //       };
//   //     });

//   //     setHeaders(filteredHeaders);
//   //     setReportDashboardData(transformedRows);
//   //     setQuestionDetailsMap(questionDetails);
//   //   } catch (error) {
//   //     console.error("Error fetching dashboard data:", error);
//   //   }
//   // };

// // Update your fetchDashboardData function to use the loading state:

//   // const fetchDashboardData = async () => {
//   //     setIsLoading(true); // Start loading
//   //     try {
//   //       const response = await fetch(
//   //         `${FULL_API_BASE_URL}/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}&page_id=${pageId}`,
//   //         {
//   //           method: "GET",
//   //           headers: {
//   //             Authorization: `Bearer ${accessToken}`,
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );

//   //       if (!response.ok) {
//   //         throw new Error("Failed to fetch dashboard data.");
//   //       }

//   //       const result = await response.json();
//   //       const { data, status, message } = result;

//   //       if (status !== 200) {
//   //         throw new Error(message || "Failed to fetch dashboard data");
//   //       }

//   //       // ... rest of your existing data processing code ...
//   //       const rawTableData = data?.table_data || [];
//   //       const rawHeaders = rawTableData[0] || [];
//   //       const rawRows = rawTableData.slice(1) || [];

//   //       const rawHeaderNames = rawHeaders.map((header) =>
//   //         header.replace(/^t\*|d\*|n\*/, "")
//   //       );
//   //       const setIdIndex = rawHeaderNames.indexOf("Set ID");

//   //       const filteredHeaders = rawHeaderNames.filter(
//   //         (header) => header !== "Set ID"
//   //       );

//   //       const transformedRows = rawRows.map((row) =>
//   //         row
//   //           .map((cell, index) => {
//   //             if (rawHeaders[index]?.startsWith("d*")) {
//   //               return new Date(cell).toLocaleDateString("en-US", {
//   //                 year: "numeric",
//   //                 month: "short",
//   //                 day: "2-digit",
//   //               });
//   //             }
//   //             return cell;
//   //           })
//   //           .filter((_, idx) => idx !== setIdIndex)
//   //       );

//   //       const questionDetails = {};
//   //       (data.result_list || []).forEach((question) => {
//   //         questionDetails[question.question_id] = {
//   //           questionId: question.question_id,
//   //           questionText: question.question_text,
//   //           questionType: question.ques_type,
//   //           options: question.options || [],
//   //           tags: question.tags || [],
//   //         };
//   //       });

//   //       setHeaders(filteredHeaders);
//   //       setReportDashboardData(transformedRows);
//   //       setQuestionDetailsMap(questionDetails);
//   //     } catch (error) {
//   //       console.error("Error fetching dashboard data:", error);
//   //     } finally {
//   //       setIsLoading(false); // Stop loading regardless of success or failure
//   //     }
//   // };

//   const fetchDashboardData = async () => {
//     setNoTimeSet(true);
//     setIsLoading(true);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Loading data, please wait...
//           </span>
//         </div>
//       </div>
//     );
//     setActiveImg(false);

//     const slowLoadingTimer = setTimeout(() => {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               This is taking longer than usual, please wait a moment...
//             </span>
//           </div>
//         </div>
//       );
//     }, 5000);

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}&page_id=${pageId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch dashboard data.");
//       }

//       const result = await response.json();
//       const { data, status, message } = result;

//       if (status !== 200) {
//         throw new Error(message || "Failed to fetch dashboard data");
//       }

//       const rawTableData = data?.table_data || [];
//       const rawHeaders = rawTableData[0] || [];
//       const rawRows = rawTableData.slice(1) || [];

//       const rawHeaderNames = rawHeaders.map((header) =>
//         header.replace(/^t\*|d\*|n\*/, "")
//       );
//       const setIdIndex = rawHeaderNames.indexOf("Set ID");

//       const filteredHeaders = rawHeaderNames.filter(
//         (header) => header !== "Set ID"
//       );

//       const transformedRows = rawRows.map((row) =>
//         row
//           .map((cell, index) => {
//             if (rawHeaders[index]?.startsWith("d*")) {
//               return new Date(cell).toLocaleDateString("en-US", {
//                 year: "numeric",
//                 month: "short",
//                 day: "2-digit",
//               });
//             }
//             return cell;
//           })
//           .filter((_, idx) => idx !== setIdIndex)
//       );

//       const questionDetails = {};
//       (data.result_list || []).forEach((question) => {
//         questionDetails[question.question_id] = {
//           questionId: question.question_id,
//           questionText: question.question_text,
//           questionType: question.ques_type,
//           options: question.options || [],
//           tags: question.tags || [],
//         };
//       });

//       setHeaders(filteredHeaders);
//       setReportDashboardData(transformedRows);
//       setQuestionDetailsMap(questionDetails);

//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(false);

//     } catch (error) {
//       clearTimeout(slowLoadingTimer);
//       setIsLoading(false);
//       setNoTimeSet(false);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//               Error: {error.message}
//             </span>
//           </div>
//         </div>
//       );
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleMarkSpecialClick = () => {
//     if (selectedRows.length === 0) {
//       setMessageBox("No questions selected!");
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             Click on Proceed to mark selected question(s) as Special
//             question(s).
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "72px" }}
//             onClick={() => confirmUpdateStatus(selectedRows, 13)} // Status 13 for Mark Special
//           >
//             Proceed
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "62px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   const handleEyeClick = (questionId) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             Do you want to change the status of this Special question to
//             general?
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "72px" }}
//             onClick={() => confirmUpdateStatus(questionId, 8)} // Status 8 for General
//           >
//             Proceed
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "62px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   const confirmUpdateStatus = async (questionIds, newStatus) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Updating the question status, please wait...</span>
//         </div>
//       </div>
//     );

//     const payload = {
//       question_ids: Array.isArray(questionIds) ? questionIds : [questionIds], // Ensure it's always an array
//       status: newStatus, // Either 8 (general) or 13 (special)
//       user_name: userName,
//     };

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/update-ques-status/`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               {newStatus === 13
//                 ? "Successfully marked the selected question(s) as Special."
//                 : "Successfully updated the question status to General."}
//             </div>
//           </div>
//         );
//         setActiveImg(InfoImg);
//         fetchDashboardData();
//         setSelectedRows([]);
//       } else {
//         throw new Error(result.message || "Failed to update status.");
//       }
//     } catch (error) {
//       console.error("Error updating question status:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             {/* <span>Failed to update status. Please try again later.</span> */}
//             <span>The question is marked special already.</span>
//           </div>
//         </div>
//       );
//     } finally {
//       setTimeout(() => setIsMessageBoxVisible(true));
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <div className="create-role-container-ques-dashboards">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Question Bank Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "160px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               onClick={handleMarkSpecialClick}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//             >
//               MARK SPECIAL
//             </button>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 width: "160px",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => {
//                 if (selectedRows.length > 0) {
//                   const queryString = selectedRows.join(","); // Join selected IDs with commas
//                   navigate(
//                     `/question_bank_review?MNTQuestionNumbers=${queryString}`
//                   ); // Pass IDs in the query string
//                 }
//               }}
//             >
//               VIEW SELECTED
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter Questions. Export a list of question or search
//           for a question. When searching, enter at least two characters in the
//           search field.
//         </p>
//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={expandedStates}
//             toggleImage={toggleImage}
//             questionDetailsMap={questionDetailsMap}
//             handleEyeClick={handleEyeClick}
//             isLoading={isLoading}
//           />
//           {/* <TablewithCheckbox
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionText={renderQuestionText}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={expandedStates}
//             toggleImage={toggleImage}
//             questionDetailsMap={questionDetailsMap}
//             handleEyeClick={handleEyeClick}
//             pageType="questionbank"
//           /> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QuestionBank;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import InfoImg from "./../../../Assets/Images/CommanImages/Informative.png";
import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
import FlagIcon from "./../../../Assets/Images/CommanImages/flag_icon.png";
import SelectDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import "../QuestionDashboard/questiondashborad.css";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import "./quesbank.css";

// ─────────────────────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────────────────────
const STATUS_OPTIONS = [
  { label: "Draft", id: 1 },
  { label: "Draft Save", id: 2 },
  { label: "Pending Faculty Review", id: 4 },
  { label: "Published", id: 8 },
  { label: "Rejected by HOD", id: 9 },
  { label: "Marked Special", id: 13 },
];

const QUES_TYPE_OPTIONS = [
  { label: "Single Correct MCQ", id: 1 },
  { label: "Multi Correct MCQ", id: 2 },
  { label: "Fill in the blanks", id: 3 },
  { label: "True/False", id: 4 },
];

// ─────────────────────────────────────────────────────────────────────────────
// TABLE COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  renderQuestionText,
  selectedRows,
  setSelectedRows,
  renderQuestionTextModel,
  expandedStates,
  questionDetailsMap,
  handleEyeClick,
  isLoading,
  currentPage,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
  onPageSizeChange,
  onSearch,
  onFilterOpen,
  onColumnSort, // ← new: called with header name when sort icon clicked
  sortColumn, // ← new: current API sort column (e.g. "Q_id")
  sortOrder, // ← new: "asc" | "desc"
  sortableColumns, // ← new: set of header names that are API-sortable
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const columnDropdownRef = useRef(null);
  const columnRef = useRef(null);
  const isResizing = useRef(false);
  const [columnWidth, setColumnWidth] = useState(400);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState([]);

  const flagCountIndex = headers.indexOf("Flag Count");
  const statusTextIndex = headers.indexOf("Status");

  useEffect(() => {
    if (headers.length > 0) {
      const initial = headers
        .filter((h) => h !== "Status" && h !== "Set ID")
        .slice(0, 5);
      setVisibleColumns([
        headers[0],
        ...initial.filter((h) => h !== headers[0]),
      ]);
    }
  }, [headers]);

  const handleColumnSelection = (column) => {
    setVisibleColumns((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(e.target)
      ) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((row) => row[0]));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (rowIndex) => {
    const questionId = data[rowIndex][0];
    setSelectedRows((prev) =>
      prev.includes(questionId)
        ? prev.filter((id) => id !== questionId)
        : [...prev, questionId]
    );
  };

  const handleMouseDown = () => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const handleMouseMove = (e) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        e.clientX - (columnRef.current?.offsetLeft || 0)
      );
      setColumnWidth(newWidth);
    }
  };
  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const renderPagination = () => {
    const pages = [];
    const addBtn = (i) =>
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          style={{ borderRadius: "5px" }}
          className={i === currentPage ? "active" : ""}
        >
          {i}
        </button>
      );
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) addBtn(i);
    } else if (currentPage <= 3) {
      for (let i = 1; i <= 3; i++) addBtn(i);
      pages.push(<span key="d1">...</span>);
      addBtn(totalPages);
    } else if (currentPage > totalPages - 3) {
      addBtn(1);
      pages.push(<span key="d1">...</span>);
      for (let i = totalPages - 2; i <= totalPages; i++) addBtn(i);
    } else {
      addBtn(1);
      pages.push(<span key="d1">...</span>);
      for (let i = currentPage - 1; i <= currentPage + 1; i++) addBtn(i);
      pages.push(<span key="d2">...</span>);
      addBtn(totalPages);
    }
    return pages;
  };

  const isAllSelected =
    selectedRows.length > 0 && selectedRows.length === data.length;

  return (
    <div>
      {/* Search + record count row */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          marginTop: "1.5%",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #6A6A6A",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <input
            type="text"
            placeholder={searchPlaceholder}
            className="search-input-ques-dash"
            onChange={(e) => onSearch(e.target.value)}
          />
          <div
            style={{
              width: "1px",
              height: "24px",
              backgroundColor: "#2F2E40",
              margin: "0 4px",
            }}
          />
          <img
            src={searchicon}
            alt="search"
            className="search-icon-ques-dash"
          />
        </div>
        <div
          style={{
            textAlign: "end",
            marginTop: "4px",
            color: "#424242",
            whiteSpace: "nowrap",
          }}
        >
          {totalCount === 0 ? (
            <span>No records</span>
          ) : (
            <>
              Displaying {(currentPage - 1) * pageSize + 1} –{" "}
              {Math.min(currentPage * pageSize, totalCount)} of {totalCount}{" "}
              records |{" "}
            </>
          )}
          {[10, 25, 50, 100, 500].map((size) => (
            <span
              key={size}
              onClick={() => onPageSizeChange(size)}
              style={{
                cursor: "pointer",
                margin: "0 5px",
                textDecoration: size === pageSize ? "none" : "underline",
                color: size === pageSize ? "black" : "#337AB7",
                fontWeight: "normal",
              }}
            >
              {size}
            </span>
          ))}
        </div>
      </div>

      {/* Toolbar: Filter + Column Selection */}
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={onFilterOpen}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc" />
              <div className="popupColumn-tc">
                {headers
                  .filter((h) => h !== "Set ID" && h !== "Status")
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                        disabled={column === "Question ID"}
                      />
                      <label>{column}</label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Table body */}
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div className="loader-tc" />
          <span style={{ color: "#6A6A6A", fontSize: "15px" }}>
            Loading questions…
          </span>
        </div>
      ) : data.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#6A6A6A",
            fontSize: "16px",
          }}
        >
          No data available
        </div>
      ) : (
        <>
          <div className="table-wrapper-cols-selections">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className="Heading-tc resizable-header"
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                        }}
                      >
                        {index === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "105px",
                            }}
                          />
                        )}
                        {heading}
                        {index === 1 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          />
                        )}
                        <img
                          onClick={() => onColumnSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                            cursor: sortableColumns.has(heading)
                              ? "pointer"
                              : "default",
                            opacity: sortableColumns.has(heading) ? 1 : 0.3,
                          }}
                          alt="sort"
                          title={sortableColumns.has(heading) ? "Sort" : ""}
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          width: cellIndex === 1 ? `${columnWidth}px` : "auto",
                          textAlign: "left",
                          color: "#6A6A6A",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: `${columnWidth}px`,
                        }}
                      >
                        {cellIndex === 0 ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="checkbox"
                              className="delete-question-checkbox-dqc"
                              checked={selectedRows.includes(row[0])}
                              onChange={() => handleRowSelect(rowIndex)}
                            />
                            <div
                              style={{
                                width: "100px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div className="flag-container-ques-bank-dash">
                                {row[flagCountIndex] > 0 && (
                                  <>
                                    <div className="flag-count-ques-bank-dash">
                                      <span>
                                        {row[flagCountIndex] > 99
                                          ? "99"
                                          : row[flagCountIndex]}
                                      </span>
                                    </div>
                                    <img
                                      src={FlagIcon}
                                      alt="flag"
                                      style={{ width: "24px" }}
                                    />
                                  </>
                                )}
                              </div>
                              <span
                                style={{
                                  width: "20px",
                                  textAlign: "center",
                                  marginRight: "40px",
                                }}
                              >
                                {row[statusTextIndex] === "Marked special" && (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEyeClick(row[0])}
                                  >
                                    <img
                                      src={EyeLockIcon}
                                      alt="eyeicon"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                )}
                              </span>
                            </div>
                            <Link
                              style={{ color: "#337ab7" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedQuestion(questionDetailsMap[row[0]]);
                                setIsQuesModalVisible(true);
                              }}
                            >
                              <span
                                className="truncated-text"
                                title={row[headers.indexOf(column)]}
                              >
                                {headers.indexOf(column) === 2
                                  ? renderQuestionText(
                                      row[headers.indexOf(column)]
                                    )
                                  : row[headers.indexOf(column)]}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          <span className="truncated-text-2">
                            {headers.indexOf(column) === 2
                              ? renderQuestionText(row[headers.indexOf(column)])
                              : row[headers.indexOf(column)]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination-tc">
            <button
              onClick={() => onPageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => onPageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      )}

      {/* Question detail modal */}
      {isQuesModalVisible && selectedQuestion && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
          style={{ cursor: "default" }}
        >
          <button
            className="modal-close-outside"
            aria-label="Close"
            onClick={(e) => {
              e.stopPropagation();
              setIsQuesModalVisible(false);
            }}
            style={{ lineHeight: "24px" }}
          >
            ✕
          </button>
          <div
            className="modal-content-all-question"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  color: "#424342",
                  margin: 0,
                  padding: "10px 14px",
                  borderBottom: "1px solid #d6d6d6",
                }}
              >
                QUESTION ID - {selectedQuestion.questionId}
              </p>
            </div>
            <div
              className="modal-question-options"
              style={{ maxHeight: "600px", overflowY: "auto", padding: "20px" }}
            >
              <p style={{ fontSize: "18px" }}>
                Question Type: {selectedQuestion.questionType}
              </p>
              {selectedQuestion.options.length > 0 ? (
                <ul style={{ marginTop: 10, paddingLeft: 20 }}>
                  <span style={{ fontSize: "18px" }}>Question:</span>
                  <span style={{ fontSize: "22px", marginLeft: "3px" }}>
                    {renderQuestionTextModel(selectedQuestion.questionText)}
                  </span>
                  {selectedQuestion.options.map((option, index) => (
                    <li
                      key={index}
                      className="option-list-item"
                      style={{
                        listStyle: "none",
                        fontSize: "22px",
                        marginTop: "15px",
                        paddingBottom: "20px",
                      }}
                    >
                      <label
                        className="toggle-radio"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          checked={option.option_correct_flag}
                          readOnly
                        />
                        <div>{renderQuestionTextModel(option.option_text)}</div>
                      </label>
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ color: "#6A6A6A" }}>No options available.</p>
              )}
              {selectedQuestion.tags.length > 0 && (
                <p
                  style={{
                    marginTop: "20px",
                    fontSize: "18px",
                    color: "#6A6A6A",
                  }}
                >
                  {selectedQuestion.tags
                    .map((tag) => {
                      if (tag.tag_type === 1) return tag.tag_value;
                      if (tag.tag_type === 2 && tag.tag_value != null)
                        return tag.tag_name;
                      return null;
                    })
                    .filter(Boolean)
                    .join(", ")}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// FILTER SIDEBAR
// Uses the project's SelectDropdown for all dropdowns (cascade + tag filters)
// ─────────────────────────────────────────────────────────────────────────────
const FilterSidebar = ({
  onClose,
  courses,
  subjects,
  chapters,
  topics,
  selectedCourse,
  selectedSubject,
  selectedChapter,
  selectedTopic,
  onCourseChange,
  onSubjectChange,
  onChapterChange,
  onTopicChange,
  loadingCascade,
  tagList,
  tagFilters,
  onTagFilterChange,
  statusFilter,
  onStatusChange,
  quesTypeFilter,
  onQuesTypeChange,
  questionIdFilter,
  onQuestionIdChange,
  searchTextFilter,
  onSearchTextChange,
  onApply,
  onReset,
}) => {
  // All non-taxonomy filters are locked until course + subject are both selected
  const taxonomyReady = !!(selectedCourse && selectedSubject);

  return (
    <div className="filter-sidebar-tc">
      <div className="filter-content-tc" style={{ position: "relative" }}>
        <button className="repman-cross-btn-HOD" onClick={onClose}>
          <p>X</p>
        </button>
        <h3 className="AdvanceF-heading-tc">Filter</h3>

        <div
          className="filter-apply-reset-ques-rev-dash"
          style={{ padding: "8px 15px" }}
        >
          <button className="apply-btn-question-review-dash" onClick={onApply}>
            APPLY
          </button>
          <button className="reset-btn-question-review-dash" onClick={onReset}>
            RESET
          </button>
        </div>

        <div className="filter-options-container">
          {/* Course → Subject → Chapter → Topic (always enabled cascade) */}
          <SelectDropdown
            label="Course"
            width="90%"
            marginLeft="15px"
            marginTop="10px"
            options={courses}
            selected={selectedCourse}
            setSelected={onCourseChange}
            placeholder="Select Course"
            disabled={loadingCascade}
            Height="auto"
            OverFlow="auto"
            minheight="200px"
          />

          <SelectDropdown
            label="Subject"
            width="90%"
            marginLeft="15px"
            marginTop="18px"
            options={subjects}
            selected={selectedSubject}
            setSelected={onSubjectChange}
            placeholder="Select Subject"
            disabled={!selectedCourse || loadingCascade}
            Height="auto"
            OverFlow="auto"
            minheight="200px"
          />

          <SelectDropdown
            label="Chapter"
            width="90%"
            marginLeft="15px"
            marginTop="18px"
            options={chapters}
            selected={selectedChapter}
            setSelected={onChapterChange}
            placeholder="Select Chapter"
            disabled={!selectedSubject || loadingCascade}
            Height="auto"
            OverFlow="auto"
            minheight="200px"
          />

          <SelectDropdown
            label="Topic"
            width="90%"
            marginLeft="15px"
            marginTop="18px"
            options={topics}
            selected={selectedTopic}
            setSelected={onTopicChange}
            placeholder="Select Topic"
            disabled={!selectedChapter || loadingCascade}
            Height="auto"
            OverFlow="auto"
            minheight="200px"
          />

          {/* All filters below disabled until Course + Subject are selected */}
          <SelectDropdown
            label="Status"
            width="90%"
            marginLeft="15px"
            marginTop="18px"
            options={STATUS_OPTIONS}
            selected={statusFilter}
            setSelected={onStatusChange}
            placeholder="Select Status"
            disabled={!taxonomyReady}
            Height="auto"
            OverFlow="auto"
            minheight="200px"
          />

          <SelectDropdown
            label="Question Type"
            width="90%"
            marginLeft="15px"
            marginTop="18px"
            options={QUES_TYPE_OPTIONS}
            selected={quesTypeFilter}
            setSelected={onQuesTypeChange}
            placeholder="Select Question Type"
            disabled={!taxonomyReady}
            Height="auto"
            OverFlow="auto"
            minheight="150px"
          />

          <div
            style={{
              marginLeft: "15px",
              marginTop: "18px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "12px",
                color: "#6A6A6A",
                marginBottom: "4px",
                fontWeight: "600",
                textTransform: "uppercase",
                opacity: taxonomyReady ? 1 : 0.4,
              }}
            >
              Question ID
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={questionIdFilter ?? ""}
              disabled={!taxonomyReady}
              onChange={(e) => {
                const raw = e.target.value.replace(/[^0-9]/g, "");
                onQuestionIdChange(raw ? Number(raw) : null);
              }}
              placeholder="Enter Question ID"
              style={{
                width: "90%",
                padding: "7px 10px",
                border: "1px solid #C8C8C8",
                borderRadius: "4px",
                fontSize: "13px",
                outline: "none",
                backgroundColor: taxonomyReady ? "#fff" : "#F5F5F5",
                cursor: taxonomyReady ? "text" : "not-allowed",
                opacity: taxonomyReady ? 1 : 0.5,
              }}
            />
          </div>

          <div
            style={{
              marginLeft: "15px",
              marginTop: "18px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                fontSize: "12px",
                color: "#6A6A6A",
                marginBottom: "4px",
                fontWeight: "600",
                textTransform: "uppercase",
                opacity: taxonomyReady ? 1 : 0.4,
              }}
            >
              Search Text
            </label>
            <input
              type="text"
              value={searchTextFilter || ""}
              disabled={!taxonomyReady}
              onChange={(e) => onSearchTextChange(e.target.value || null)}
              placeholder="Search inside questions…"
              style={{
                width: "90%",
                padding: "7px 10px",
                border: "1px solid #C8C8C8",
                borderRadius: "4px",
                fontSize: "13px",
                outline: "none",
                backgroundColor: taxonomyReady ? "#fff" : "#F5F5F5",
                cursor: taxonomyReady ? "text" : "not-allowed",
                opacity: taxonomyReady ? 1 : 0.5,
              }}
            />
          </div>

          {/* Dynamic tag_list filters — also locked until course+subject */}
          {Object.keys(tagList).length > 0 &&
            Object.entries(tagList).map(([tagName, tagValues]) => (
              <SelectDropdown
                key={tagName}
                label={tagName}
                width="90%"
                marginLeft="15px"
                marginTop="18px"
                options={tagValues.map((v) => ({
                  id: v.tag_value_id,
                  label: String(v.tag_value),
                }))}
                selected={tagFilters[tagName] ?? null}
                setSelected={(val) => onTagFilterChange(tagName, val)}
                placeholder={`Select ${tagName}`}
                disabled={!taxonomyReady}
                Height="auto"
                OverFlow="auto"
                minheight="150px"
              />
            ))}
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const QuestionBank = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const navigate = useNavigate();

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const accessToken = localStorage.getItem("other");

  // ── Table state ────────────────────────────────────────────────────────────
  const [headers, setHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [questionDetailsMap, setQuestionDetailsMap] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [expandedStates, setExpandedStates] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // ── Server-side pagination ─────────────────────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25); // default 25 per spec
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // ── Filter sidebar ─────────────────────────────────────────────────────────
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  // ── tag_list from API ──────────────────────────────────────────────────────
  const [tagList, setTagList] = useState({});
  const tagIdMapRef = useRef({}); // { tagName: parse_tag_id }

  // ── Cascade dropdown data ──────────────────────────────────────────────────
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [loadingCascade, setLoadingCascade] = useState(false);

  // ── PENDING filter state (sidebar — not yet applied) ──────────────────────
  const [pendingCourse, setPendingCourse] = useState(null);
  const [pendingSubject, setPendingSubject] = useState(null);
  const [pendingChapter, setPendingChapter] = useState(null);
  const [pendingTopic, setPendingTopic] = useState(null);
  const [pendingTagFilters, setPendingTagFilters] = useState({});
  const [pendingStatus, setPendingStatus] = useState(null);
  const [pendingQuesType, setPendingQuesType] = useState(null);
  const [pendingQuestionId, setPendingQuestionId] = useState(null);
  const [pendingSearchText, setPendingSearchText] = useState(null);

  // ── APPLIED filter state (last sent to API) ────────────────────────────────
  const [appliedFilters, setAppliedFilters] = useState({});

  // ── Sort state (server-side) ───────────────────────────────────────────────
  // Maps visible header name → API column literal
  const SORT_COLUMN_MAP = {
    "Question ID": "Q_id",
    "Set Name": "set_id",
    "Question Type": "q_type_id",
  };
  const [sortColumn, setSortColumn] = useState("Q_id");
  const [sortOrder, setSortOrder] = useState("desc");

  // ── Search debounce ────────────────────────────────────────────────────────
  const searchDebounceRef = useRef(null);

  // ── Load courses once ──────────────────────────────────────────────────────
  useEffect(() => {
    fetchCourses();
  }, []);

  // ── Initial fetch on mount (empty filters, page 1, size 25) ───────────────
  useEffect(() => {
    if (dataClient) {
      fetchQuestions(1, 25, {});
    }
  }, [dataClient]);

  // ─────────────────────────────────────────────────────────────────────────
  // CASCADE LOADERS
  // ─────────────────────────────────────────────────────────────────────────
  const fetchCourses = async () => {
    try {
      const res = await fetch(`${FULL_API_BASE_URL}/get-courses/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const json = await res.json();
      const list = json?.data || json || [];
      setCourses(list.map((c) => ({ id: c.course_id, label: c.course_name })));
    } catch (e) {
      console.error("fetchCourses:", e);
    }
  };

  const fetchSubjects = async (courseId) => {
    if (!courseId) {
      setSubjects([]);
      return;
    }
    setLoadingCascade(true);
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${courseId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const json = await res.json();
      const list = json?.data || json || [];
      setSubjects(
        list.map((s) => ({ id: s.subject_id, label: s.subject_name }))
      );
    } catch (e) {
      console.error("fetchSubjects:", e);
    } finally {
      setLoadingCascade(false);
    }
  };

  const fetchChapters = async (subjectId) => {
    if (!subjectId) {
      setChapters([]);
      return;
    }
    setLoadingCascade(true);
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const json = await res.json();
      const list = json?.data || json || [];
      setChapters(
        list.map((c) => ({ id: c.chapter_id, label: c.chapter_name }))
      );
    } catch (e) {
      console.error("fetchChapters:", e);
    } finally {
      setLoadingCascade(false);
    }
  };

  const fetchTopics = async (chapterId) => {
    if (!chapterId) {
      setTopics([]);
      return;
    }
    setLoadingCascade(true);
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const json = await res.json();
      const list = json?.data || json || [];
      setTopics(list.map((t) => ({ id: t.topic_id, label: t.topic_name })));
    } catch (e) {
      console.error("fetchTopics:", e);
    } finally {
      setLoadingCascade(false);
    }
  };

  // ── Cascade change handlers ────────────────────────────────────────────────
  const handleCourseChange = (val) => {
    setPendingCourse(val);
    setPendingSubject(null);
    setSubjects([]);
    setPendingChapter(null);
    setChapters([]);
    setPendingTopic(null);
    setTopics([]);
    if (val) fetchSubjects(val);
  };
  const handleSubjectChange = (val) => {
    setPendingSubject(val);
    setPendingChapter(null);
    setChapters([]);
    setPendingTopic(null);
    setTopics([]);
    if (val) fetchChapters(val);
  };
  const handleChapterChange = (val) => {
    setPendingChapter(val);
    setPendingTopic(null);
    setTopics([]);
    if (val) fetchTopics(val);
  };
  const handleTopicChange = (val) => {
    setPendingTopic(val);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // BUILD API PAYLOAD
  // filters object is intentionally minimal — only include keys that have values.
  // On first load filters = {} so body is { page:1, page_size:25, filters:{} }
  // ─────────────────────────────────────────────────────────────────────────
  const buildPayload = (page, size, filters, searchOverride, col, ord) => {
    const filtersObj = {};

    // search_text — from top bar (searchOverride) or from sidebar pending
    const searchVal =
      searchOverride !== undefined
        ? searchOverride
        : filters.searchText || null;
    if (searchVal) filtersObj.search_text = searchVal;

    // status id
    if (filters.statusId != null) filtersObj.status = filters.statusId;

    // question type id
    if (filters.quesTypeId != null)
      filtersObj.ques_type_id = filters.quesTypeId;

    // question id
    if (filters.questionId != null) filtersObj.question_id = filters.questionId;

    // tags array — taxonomy + tag filters
    const tags = [];

    // taxonomy: most-specific wins
    if (filters.topic != null)
      tags.push({
        parse_tag_id: tagIdMapRef.current["Topic"] || null,
        parse_tag_value_id: filters.topic,
      });
    else if (filters.chapter != null)
      tags.push({
        parse_tag_id: tagIdMapRef.current["Chapter"] || null,
        parse_tag_value_id: filters.chapter,
      });
    else if (filters.subject != null)
      tags.push({
        parse_tag_id: tagIdMapRef.current["Subject"] || null,
        parse_tag_value_id: filters.subject,
      });
    else if (filters.course != null)
      tags.push({
        parse_tag_id: tagIdMapRef.current["Course"] || null,
        parse_tag_value_id: filters.course,
      });

    // other tag filters from tagList dropdowns
    if (filters.tagFilters) {
      Object.entries(filters.tagFilters).forEach(([tagName, tagValueId]) => {
        if (tagValueId == null) return;
        const tid = tagIdMapRef.current[tagName];
        if (tid)
          tags.push({
            parse_tag_id: tid,
            parse_tag_value_id: Number(tagValueId),
          });
      });
    }

    if (tags.length > 0) filtersObj.tags = tags;

    return {
      page,
      page_size: size,
      filters: filtersObj,
      sort: { column: col || sortColumn, order: ord || sortOrder },
    };
  };

  // ─────────────────────────────────────────────────────────────────────────
  // MAIN FETCH
  // ─────────────────────────────────────────────────────────────────────────
  const fetchQuestions = async (
    page,
    size,
    filters,
    searchOverride,
    col,
    ord
  ) => {
    setIsLoading(true);
    setNoTimeSet(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc" />
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait…
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    const slowTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc" />
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual…
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const payload = buildPayload(
        page,
        size,
        filters,
        searchOverride,
        col,
        ord
      );
      console.log("QuestionBank payload →", JSON.stringify(payload, null, 2));

      const res = await fetch(
        `${FULL_API_BASE_URL}/get-questions-for-review-v2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Network error: " + res.status);

      const result = await res.json();
      const { data, status, message } = result;
      if (status !== 200) throw new Error(message || "API returned error");

      // ── Process table_data ───────────────────────────────────────────────
      const rawTableData = data?.table_data || [];
      const rawHeaders = rawTableData[0] || [];
      const rawRows = rawTableData.slice(1) || [];
      const rawHeaderNames = rawHeaders.map((h) => h.replace(/^[tdn]\*/, ""));
      const setIdIndex = rawHeaderNames.indexOf("Set ID");
      const filteredHeaders = rawHeaderNames.filter((h) => h !== "Set ID");

      const transformedRows = rawRows.map((row) =>
        row
          .map((cell, idx) => {
            if (rawHeaders[idx]?.startsWith("d*") && cell) {
              return new Date(cell).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              });
            }
            return cell;
          })
          .filter((_, idx) => idx !== setIdIndex)
      );

      // ── Question detail map ──────────────────────────────────────────────
      const qMap = {};
      (data.result_list || []).forEach((q) => {
        qMap[q.question_id] = {
          questionId: q.question_id,
          questionText: q.question_text,
          questionType: q.ques_type,
          options: q.options || [],
          tags: q.tags || [],
        };
      });

      // ── Build tagIdMap from result_list tags ─────────────────────────────
      const newTagIdMap = { ...tagIdMapRef.current };
      (data.result_list || []).forEach((q) => {
        (q.tags || []).forEach((tag) => {
          if (tag.tag_name && tag.tag_id && !newTagIdMap[tag.tag_name]) {
            newTagIdMap[tag.tag_name] = tag.tag_id;
          }
        });
      });
      tagIdMapRef.current = newTagIdMap;

      // ── Update state ─────────────────────────────────────────────────────
      setHeaders(filteredHeaders);
      setTableData(transformedRows);
      setQuestionDetailsMap(qMap);
      setTotalCount(data.total_count || 0);
      setTotalPages(data.total_pages || 0);
      setCurrentPage(data.page || page);

      if (data.tag_list && Object.keys(data.tag_list).length > 0) {
        setTagList(data.tag_list);
      }

      clearTimeout(slowTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(false);
    } catch (err) {
      clearTimeout(slowTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {err.message}
            </span>
          </div>
        </div>
      );
      console.error("fetchQuestions error:", err);
    }
  };

  // ── Apply filters (APPLY button) ───────────────────────────────────────────
  const handleApplyFilters = () => {
    const newFilters = {
      course: pendingCourse,
      subject: pendingSubject,
      chapter: pendingChapter,
      topic: pendingTopic,
      tagFilters: pendingTagFilters,
      statusId: pendingStatus, // numeric id
      quesTypeId: pendingQuesType, // numeric id
      questionId: pendingQuestionId,
      searchText: pendingSearchText,
    };
    setAppliedFilters(newFilters);
    setCurrentPage(1);
    setIsFilterVisible(false);
    fetchQuestions(1, pageSize, newFilters);
  };

  // ── Reset filters ──────────────────────────────────────────────────────────
  const handleResetFilters = () => {
    setPendingCourse(null);
    setPendingSubject(null);
    setPendingChapter(null);
    setPendingTopic(null);
    setSubjects([]);
    setChapters([]);
    setTopics([]);
    setPendingTagFilters({});
    setPendingStatus(null);
    setPendingQuesType(null);
    setPendingQuestionId(null);
    setPendingSearchText(null);
    setAppliedFilters({});
    setCurrentPage(1);
    fetchQuestions(1, pageSize, {});
  };

  // ── Tag filter change in sidebar ───────────────────────────────────────────
  const handleTagFilterChange = (tagName, valueId) => {
    setPendingTagFilters((prev) => ({ ...prev, [tagName]: valueId ?? null }));
  };

  // ── Search bar (debounced, hits API) ──────────────────────────────────────
  const handleSearch = (val) => {
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      const newFilters = { ...appliedFilters, searchText: val || null };
      setAppliedFilters(newFilters);
      fetchQuestions(1, pageSize, newFilters, val || null);
    }, 1000);
  };

  // ── Pagination ─────────────────────────────────────────────────────────────
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchQuestions(page, pageSize, appliedFilters);
  };
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
    fetchQuestions(1, size, appliedFilters);
  };

  // ── Column sort (server-side for Q_id, set_id, q_type_id) ─────────────────
  const handleColumnSort = (headerName) => {
    const apiCol = SORT_COLUMN_MAP[headerName];
    if (!apiCol) return; // column not sortable via API — ignore
    const newOrder =
      sortColumn === apiCol && sortOrder === "desc" ? "asc" : "desc";
    setSortColumn(apiCol);
    setSortOrder(newOrder);
    fetchQuestions(
      currentPage,
      pageSize,
      appliedFilters,
      undefined,
      apiCol,
      newOrder
    );
  };

  // ── Question text renderers ────────────────────────────────────────────────
  const renderQuestionText = (questionText) => {
    const decoded = he.decode(String(questionText || ""));
    return decoded.split(/(imgsrc=[^ ]+)/g).map((seg, i) => {
      if (seg.startsWith("imgsrc=")) {
        return (
          <img
            key={i}
            src={seg.replace("imgsrc=", "")}
            alt=""
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      }
      return (
        <span key={i} className="truncated-text-3">
          <Latex>{seg}</Latex>
        </span>
      );
    });
  };

  const toggleImage = (key) =>
    setExpandedStates((prev) => ({ ...prev, [key]: !prev[key] }));

  const renderQuestionTextModel = (questionText) => {
    const decoded = he.decode(String(questionText || ""));
    return (
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {decoded.split(/(imgsrc=[^ ]+)/g).map((seg, i) => {
          if (seg.startsWith("imgsrc=")) {
            const url = seg.replace("imgsrc=", "");
            const key = `${questionText}-${i}`;
            const expanded = expandedStates[key] || false;
            return (
              <img
                key={i}
                src={url}
                alt=""
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: expanded ? "450px" : "200px",
                  maxHeight: expanded ? "550px" : "250px",
                  objectFit: "contain",
                  margin: "0 5px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleImage(key);
                }}
              />
            );
          }
          return (
            <span key={i} style={{ margin: "0 5px" }}>
              <Latex>{seg}</Latex>
            </span>
          );
        })}
      </div>
    );
  };

  // ── Status update (Mark Special / Eye click) ───────────────────────────────
  const handleMarkSpecialClick = () => {
    if (selectedRows.length === 0) {
      setMessageBox("No questions selected!");
      setIsMessageBoxVisible(true);
      return;
    }
    setIsMessageBoxVisible(true);
    setActiveImg(InterogativeImg);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Click Proceed to mark selected question(s) as Special.</span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "72px" }}
            onClick={() => confirmUpdateStatus(selectedRows, 13)}
          >
            Proceed
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "62px" }}
            onClick={() => setIsMessageBoxVisible(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const handleEyeClick = (questionId) => {
    setIsMessageBoxVisible(true);
    setActiveImg(InterogativeImg);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Change this Special question to General?</span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "72px" }}
            onClick={() => confirmUpdateStatus(questionId, 8)}
          >
            Proceed
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "62px" }}
            onClick={() => setIsMessageBoxVisible(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const confirmUpdateStatus = async (questionIds, newStatus) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc" />
          <span>Updating status…</span>
        </div>
      </div>
    );
    try {
      const res = await fetch(`${FULL_API_BASE_URL}/update-ques-status/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          question_ids: Array.isArray(questionIds)
            ? questionIds
            : [questionIds],
          status: newStatus,
          user_name: userName,
        }),
      });
      const result = await res.json();
      if (res.ok) {
        setActiveImg(InfoImg);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              {newStatus === 13
                ? "Marked as Special successfully."
                : "Status updated to General."}
            </div>
          </div>
        );
        fetchQuestions(currentPage, pageSize, appliedFilters);
        setSelectedRows([]);
      } else {
        throw new Error(result.message || "Failed to update status.");
      }
    } catch (err) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>The question may already be marked special.</span>
          </div>
        </div>
      );
    } finally {
      setTimeout(() => setIsMessageBoxVisible(true));
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        {/* Header */}
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Question Bank Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "160px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              onClick={handleMarkSpecialClick}
              disabled={selectedRows.length === 0}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
            >
              MARK SPECIAL
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "160px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={() => {
                if (selectedRows.length > 0)
                  navigate(
                    `/question_bank_review?MNTQuestionNumbers=${selectedRows.join(
                      ","
                    )}`
                  );
              }}
            >
              VIEW SELECTED
            </button>
          </div>
        </div>

        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter Questions. Export a list of questions or
          search for a question.
        </p>

        <TableComponent
          headers={headers}
          data={tableData}
          searchPlaceholder="Search questions…"
          renderQuestionText={renderQuestionText}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          renderQuestionTextModel={renderQuestionTextModel}
          expandedStates={expandedStates}
          toggleImage={toggleImage}
          questionDetailsMap={questionDetailsMap}
          handleEyeClick={handleEyeClick}
          isLoading={isLoading}
          currentPage={currentPage}
          pageSize={pageSize}
          totalCount={totalCount}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onSearch={handleSearch}
          onFilterOpen={() => setIsFilterVisible(true)}
          onColumnSort={handleColumnSort}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          sortableColumns={new Set(Object.keys(SORT_COLUMN_MAP))}
        />
      </div>

      {/* Filter Sidebar */}
      {isFilterVisible && (
        <FilterSidebar
          onClose={() => setIsFilterVisible(false)}
          courses={courses}
          subjects={subjects}
          chapters={chapters}
          topics={topics}
          selectedCourse={pendingCourse}
          selectedSubject={pendingSubject}
          selectedChapter={pendingChapter}
          selectedTopic={pendingTopic}
          onCourseChange={handleCourseChange}
          onSubjectChange={handleSubjectChange}
          onChapterChange={handleChapterChange}
          onTopicChange={handleTopicChange}
          loadingCascade={loadingCascade}
          tagList={tagList}
          tagFilters={pendingTagFilters}
          onTagFilterChange={handleTagFilterChange}
          statusFilter={pendingStatus}
          onStatusChange={setPendingStatus}
          quesTypeFilter={pendingQuesType}
          onQuesTypeChange={setPendingQuesType}
          questionIdFilter={pendingQuestionId}
          onQuestionIdChange={setPendingQuestionId}
          searchTextFilter={pendingSearchText}
          onSearchTextChange={setPendingSearchText}
          onApply={handleApplyFilters}
          onReset={handleResetFilters}
        />
      )}
    </div>
  );
};

export default QuestionBank;
